import "./UserPanel.scss";

import { useMemo, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import DropDownButton from "devextreme-react/drop-down-button";
import List from 'devextreme-react/list';
import { useUserSessionContext } from "../../contexts/UserSessionContext";
import { useOAuth2Context } from "../../contexts/OAuth2Context";
import { useScreenSize } from "../../utils/media-query";

export default function UserPanel() {
    const { userManager } = useOAuth2Context();
    const { user } = useUserSessionContext();
    const { isXSmall, isSmall } = useScreenSize();

    const navigate = useNavigate();
    const buttonRef = useRef<any>(null);
    const userEmail = user ? user.email : "";

    const navigateToProfile = useCallback(() => {
        navigate("/home");
    }, [navigate]);

    const menuItems = useMemo(
        () => [
            { text: userEmail },
            // { text: "Profilo", icon: "", onClick: navigateToProfile },
            { text: "Logout", icon: "runner", onClick: () => userManager.signoutRedirect() }
        ],
        [navigateToProfile, userManager, userEmail]
    );

    if (isSmall || isXSmall) {
        return (
            <div className="user-panel mobile">
                <div className="user-info">
                    <div className="user-name">{user?.descrizione}</div>
                </div>

                <List
                    items={menuItems}
                    selectionMode="none"
                    focusStateEnabled={false}
                    activeStateEnabled={false}
                    onItemClick={(e) => e.itemData?.onClick?.()}
                />
            </div>
        )
    }

    return (
        <div className="user-panel desktop">
            <DropDownButton
                ref={buttonRef}
                text={user?.descrizione}
                stylingMode="text"
                showArrowIcon={false}
                elementAttr={{ class: 'user-button' }}
                dropDownOptions={{ 
                    width: 'auto',
                    closeOnOutsideClick: true 
                }}
                dropDownContentRender={() => (
                    <List
                        items={menuItems}
                        selectionMode="none"
                        focusStateEnabled={false}
                        activeStateEnabled={false}
                        onItemClick={(e) => e.itemData?.onClick?.()}
                    />
                )}
            />
        </div>
    );
}
